import { render, staticRenderFns } from "./contract-nganluong.vue?vue&type=template&id=f48bdd2a"
import script from "./contract-nganluong.vue?vue&type=script&lang=js"
export * from "./contract-nganluong.vue?vue&type=script&lang=js"
import style0 from "./contract-nganluong.vue?vue&type=style&index=0&id=f48bdd2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports